import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import NoData from "../../NoData";
import Loading from "../../Loading";
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import { IoEyeOutline } from "react-icons/io5";


export default function SubscriptionHistory() {

    DataTable.use(DT);
    const [subscriptionHistory, setSubscriptionHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const adminToken = localStorage.getItem("authAdminToken");

    // Show Details Section
    const fetchAllSubscription = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/getSubscriptionHistory`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${adminToken}`
            },
        });
        return response.json();
    };

    useEffect(() => {
        fetchAllSubscription().then((res) => {
            if (res.status) {
                setLoading(false);
                setSubscriptionHistory(res.subscriptionHistory);
            } else {
                toast.error("Unable to load user details. Please try again later.");
            }
        }).catch((error) => {
            toast.error("Failed to fetch users. Please check your connection and try again.");
        });
    }, []);

    function formatUnixDate(unixTime) {
        // If timestamp is in seconds, convert to milliseconds
        if (unixTime.toString().length === 10) {
            unixTime *= 1000;
        }

        const date = new Date(Number(unixTime));

        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "long" }); // "October"
        const year = date.getFullYear();

        return `${day} ${month} ${year}`;
    }

    function formatIsoDate(isoDate) {
        // If timestamp is in seconds, convert to milliseconds
        const unixTime = new Date(isoDate).getTime()
        if (unixTime.toString().length === 10) {
            unixTime *= 1000;
        }

        const date = new Date(Number(unixTime));

        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "long" }); // "October"
        const year = date.getFullYear();

        return `${day} ${month} ${year}`;
    }

    return (
        <>
            {/* Toast container */}
            < ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            {loading ?
                <Loading />
                :
                <div className="container-xxl flex-grow-1 container-p-y my-5 px-3" style={{ margin: "4em 20em" }}>
                    <div className="card shadow-sm border-0">
                        <div className="card-header d-flex justify-content-between align-items-center bg-white border-bottom-0">
                            <h5 className="card-title mb-0">User Subscription History</h5>
                        </div>

                        {subscriptionHistory.length > 0 ?
                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <DataTable data={subscriptionHistory.map((subhistory, index) => [index + 1, subhistory.first_name + " " + subhistory.last_name,
                                    subhistory.email, subhistory.name,
                                    formatIsoDate(subhistory.created_on), formatUnixDate(subhistory.expire_on),
                                    ])} className="display">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Subscription Name</th>
                                                <th>Created Date</th>
                                                <th>Expire Date</th>
                                            </tr>
                                        </thead>
                                    </DataTable>
                                </div>
                            </div>
                            :
                            <NoData />
                        }

                    </div>
                </div>
            }

        </>
    )
}
